import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { Divider } from "@gemini/ui";
import { SimilarListingsCarousel } from "./SimilarListingsCarousel";
export const similarListingsTestId = "cdp-similar-listings";
export const similarProviderListingsTestId = "cdp-similar-provider-listings";
export const SimilarListings = ({ similarListings, similarRecords, isDisplayed, funnelUrl, isSimilarProviderListings = false, isErrorPageDisplay = false, }) => {
    const testId = isSimilarProviderListings
        ? similarProviderListingsTestId
        : similarListingsTestId;
    return (_jsxs(_Fragment, { children: [isDisplayed && funnelUrl && (_jsx(Box, { paddingHorizontal: {
                    "breakpoint.base": "spacing.16",
                    "breakpoint.sm": "spacing.32",
                    "breakpoint.lg": "spacing.none",
                }, gridColumn: {
                    "breakpoint.base": "col-start / span 4",
                    "breakpoint.md": "col-start / span 4",
                    "breakpoint.lg": "col-start / span 12",
                    "breakpoint.sm": "col-start / span 8",
                    "breakpoint.xl": "col-start 1 / span 12",
                    "breakpoint.xxl": "col-start 2 / span 10",
                }, children: _jsx(Divider, { "aria-hidden": "true", marginVertical: "spacing.8" }) })), _jsx(Box, { as: "section", id: "similarListings", testId: testId, gridColumn: {
                    "breakpoint.base": "col-start / span 4",
                    "breakpoint.md": "col-start / span 4",
                    "breakpoint.lg": "col-start / span 12",
                    "breakpoint.sm": "col-start / span 8",
                    "breakpoint.xl": "col-start 1 / span 12",
                    "breakpoint.xxl": "col-start 2 / span 10",
                }, marginBottom: (similarListings === null || similarListings === void 0 ? void 0 : similarListings.length)
                    ? {
                        "breakpoint.lg": "spacing.16",
                    }
                    : "spacing.0", overflow: "clip", position: "relative", unsafe_className: "HideOnPrint", paddingLeft: {
                    "breakpoint.base": "spacing.16",
                    "breakpoint.sm": "spacing.32",
                    "breakpoint.lg": "spacing.none",
                }, children: _jsx(SimilarListingsCarousel, { similarListings: similarListings || [], similars: similarRecords || undefined, display: isDisplayed, isSimilarProviderListings: isSimilarProviderListings, isErrorPageDisplay: isErrorPageDisplay }) })] }));
};
